import { useFormContext } from "react-hook-form";

const noop = () => undefined;

const FALLBACK_FORM_CONTEXT = Object.freeze({
  watch: () => ({}),
  getValues: () => ({}),
  setValue: noop,
  setError: noop,
  clearErrors: noop,
  trigger: async () => true,
  reset: noop,
  control: {},
  formState: { errors: {} },
});

/**
 * react-hook-form context with a no-op fallback for blocks rendered outside a provider
 * (e.g. static cart drawer upsell before form mount).
 */
export function usePopupFormContext() {
  const ctx = useFormContext();
  return ctx ?? FALLBACK_FORM_CONTEXT;
}
